import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import {
  DefaultBasePathMenu,
  NavMenuItems,
  UserMenuItems,
} from "../Constants/Constants";
import { LoginPage } from "./UserLogin/LoginPage";
import { PrivateRoute } from "./Common/PrivateRoute";
import { setBaseURL } from "../Store/apiStore";
import TipsPage from "./TipsPage";
import AboutPage from "./AboutPage";
import SupportView from "./DeviceManagement/SupportView";
import DeviceProvisioning from "./DeviceManagement/DeviceProvisioning";
import OrderManagement from "./DeviceManagement/OrderManagement";
import GroupManagement from "./DeviceManagement/GroupManagement";
import NetworkDashboard from "./DeviceManagement/NetworkDashboard";
import CodeUpgradeManagement from "./DeviceManagement/CodeUpgradeManagement";
import { Access, getUserFeatureList } from "./AccessControl/General";
import Settings from "./Settings/Settings";

const Routes = () => {
  const dispatch = useDispatch();
  useMemo(() => {
    const { protocol, hostname } = window.location;
    const apiUrl = protocol + "//" + hostname;
    dispatch(setBaseURL(apiUrl));
  }, []);

  const currentUser = useSelector((state) => state.auth.currentUser);
  const userFeatures = useMemo(() => getUserFeatureList(), [currentUser]);
  /* Check in same order as Menu order array in MainPage */
  const defaultBaseMenuComponent = useMemo(() => {
    return DefaultBasePathMenu === NavMenuItems.tips.key
      ? TipsPage
      : userFeatures.includes(Access.menu.support)
      ? SupportView
      : userFeatures.includes(Access.menu.device)
      ? DeviceProvisioning
      : userFeatures.includes(Access.menu.order)
      ? OrderManagement
      : userFeatures.includes(Access.menu.asset)
      ? CodeUpgradeManagement
      : userFeatures.includes(Access.menu.group)
      ? GroupManagement
      : TipsPage;
  }, [userFeatures]);

  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute exact path="/" component={defaultBaseMenuComponent} />
        <PrivateRoute
          exact
          component={SupportView}
          path={"/" + NavMenuItems.support.key}
        />
        <PrivateRoute
          exact
          component={DeviceProvisioning}
          path={"/" + NavMenuItems.device.key}
        />
        <PrivateRoute
          exact
          component={GroupManagement}
          path={"/" + NavMenuItems.group.key}
        />
        <PrivateRoute
          exact
          component={OrderManagement}
          path={"/" + NavMenuItems.order.key}
        />
        <PrivateRoute
          exact
          component={OrderManagement}
          path={"/" + NavMenuItems.order.key + '/:orderType'}
        />
        <PrivateRoute
          exact
          component={CodeUpgradeManagement}
          path={"/" + NavMenuItems.asset.key}
        />
        <PrivateRoute
          exact
          component={NetworkDashboard}
          path={"/" + NavMenuItems.network.key}
        />
        <PrivateRoute
          exact
          component={Settings}
          path={"/" + UserMenuItems.updatePassword.key}
        />
        <PrivateRoute
          exact
          component={AboutPage}
          path={"/" + NavMenuItems.about.key}
        />
        <PrivateRoute
          exact
          component={TipsPage}
          path={"/" + NavMenuItems.tips.key}
        />

        <Route path="/login" component={LoginPage} />

        {/* TODO: redirect to page does not exist */}
        <Redirect to="/login" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
